export interface MemoryCache {
  idToken?: string;
  isFirebaseInitialized: boolean;
}

export const memoryCache: MemoryCache = {
  idToken: undefined, // Firebase idToken
  isFirebaseInitialized: false, // whether Firebase auth has been initialized
};
